<template lang="pug">
GenericCard(size='33')
  SellerChooserCore.flex-fill(
    @input='$emit(`input`, $event)'

    @selectedIndexChanged='selectedSellersIndex = $event'
    :selectedSellersIndex='selectedSellersIndex'
  )
</template>

<script>
/* eslint-disable arrow-body-style, no-unused-vars */
import SellerChooserCore from './SellerChooserCore.vue';

export default {
  data: () => ({
    selectedSellersIndex: [],
  }),
  components: {
    SellerChooserCore,
  },
};
</script>

<style lang="scss">
// .seller-chooser {
//   .sell-record-list {
//     min-height: 100px;
//   }
// }
</style>
